export const siteConfig = {
  name: "BuildZone",
  shortName: "BuildZone",
  legalName: "BuildZone Technology (Pvt) Ltd.",
  tagline: "BEST SOFTWARE AGENCY IN SIALKOT | GLOBAL SOFTWARE & AI ENGINEERING",
  subheading: "BuildZone Technology is the best software agency in Sialkot, delivering custom enterprise ERPs, web platforms, mobile apps, and AI automation for global businesses.",
  description: "BuildZone is the best software agency in Sialkot. We engineer custom software, mobile apps, enterprise ERPs, and AI solutions for global clients.",
  url: "https://buildzonetechnology.com",
  foundedYear: 2020,
  
  // Contact details
  contact: {
    email: "info@buildzonetechnology.com",
    alternateEmail: "buildzonetechnology@gmail.com",
    salesEmail: "info@buildzonetechnology.com",
    careersEmail: "buildzonetechnology@gmail.com",
    phone: "+92105464116",
    formattedPhone: "+92 105 464116",
    whatsapp: "+92105464116",
    whatsappLink: "https://wa.me/92105464116",
    address: "Executive Tech District, Paris Road",
    city: "Sialkot",
    state: "Punjab",
    country: "Pakistan & Worldwide",
    postalCode: "51310",
    timezone: "PKT (UTC+5) / Global 24/7",
    hours: "Mon - Sat: 9:00 AM - 7:00 PM (24/7 On-Call Support for Enterprise)",
  },



  // Social Links
  social: {
    linkedin: "https://linkedin.com/company/buildzone-tech",
    github: "https://github.com/buildzone-tech",
    twitter: "https://twitter.com/buildzone_tech",
    instagram: "https://instagram.com/buildzone.official",
    facebook: "https://facebook.com/buildzonetech",
    tiktok: "https://tiktok.com/@buildzone_dev",
    youtube: "https://youtube.com/@buildzone_tech",
    discord: "https://discord.gg/buildzone",
  },

  socialVisibility: {
    whatsapp: true,
    instagram: true,
    facebook: true,
    tiktok: true,
    linkedin: true,
    youtube: true,
    github: true,
    twitter: true,
  },

  // Brand aesthetics
  brand: {
    primaryColor: "#00F0FF",
    secondaryColor: "#7928CA",
    darkBackground: "#06080F",
    accentColor: "#10B981",
  },

  // Main Nav Links
  navLinks: [
    {
      title: "Services",
      href: "/services",
      dropdown: [
        { title: "Web Development", href: "/services/web-development", desc: "Next-gen enterprise web platforms & PWAs" },
        { title: "Mobile App Development", href: "/services/mobile-app-development", desc: "Native & cross-platform iOS & Android apps" },
        { title: "AI & Intelligent Automation", href: "/ai-development", desc: "LLMs, RAG, agents & autonomous workflows" },
        { title: "Custom Software", href: "/services/custom-software", desc: "Bespoke mission-critical software systems" },
        { title: "SaaS Development", href: "/services/saas-development", desc: "Multi-tenant cloud SaaS products" },
        { title: "E-Commerce Systems", href: "/services/e-commerce", desc: "High-scale commerce & checkout engines" },
        { title: "UI/UX & Product Design", href: "/services/ui-ux-design", desc: "Modern human-centered digital experiences" },
        { title: "Cloud & DevOps", href: "/services/cloud-devops", desc: "AWS, Kubernetes, CI/CD & microservices" },
      ]
    },
    {
      title: "Solutions",
      href: "/ai-development",
      dropdown: [
        { title: "AI Development & Agents", href: "/ai-development", desc: "Enterprise LLM applications & automated agents" },
        { title: "Security & Compliance", href: "/security", desc: "Bank-grade enterprise security architecture" },
        { title: "Technologies & Stack", href: "/technologies", desc: "Our verified modern engineering stack" },
      ]
    },
    {
      title: "Industries",
      href: "/industries",
      dropdown: [
        { title: "Healthcare & MedTech", href: "/industries/healthcare", desc: "HIPAA compliant medical platforms" },
        { title: "FinTech & Banking", href: "/industries/fintech", desc: "Secure transaction processing & digital banking" },
        { title: "E-Commerce & Retail", href: "/industries/e-commerce", desc: "High-load omnichannel commerce platforms" },
        { title: "Education & EdTech", href: "/industries/education", desc: "Interactive LMS & virtual learning systems" },
        { title: "Logistics & Supply Chain", href: "/industries/logistics", desc: "Real-time dispatch & warehouse tracking" },
        { title: "Real Estate & PropTech", href: "/industries/real-estate", desc: "Smart asset management & 3D portals" },
      ]
    },
    {
      title: "Work",
      href: "/portfolio",
      dropdown: [
        { title: "Portfolio Gallery", href: "/portfolio", desc: "Explore our latest shipped client products" },
        { title: "In-Depth Case Studies", href: "/case-studies", desc: "Detailed engineering & business metrics" },
        { title: "Tech Stack & Tools", href: "/technologies", desc: "Our verified modern engineering stack" },
      ]
    },
    {
      title: "About",
      href: "/about",
      dropdown: [
        { title: "Our Story & Vision", href: "/about", desc: "Who we are and our engineering principles" },
        { title: "Leadership Team", href: "/team", desc: "Meet the engineering partners" },
        { title: "Careers & Jobs", href: "/careers", desc: "Join our global engineering team" },
      ]
    },
    {
      title: "Insights",
      href: "/blog",
      dropdown: [
        { title: "Engineering Blog", href: "/blog", desc: "Articles on architecture, AI, and scale" },
        { title: "Frequently Asked Questions", href: "/faq", desc: "Answers to common client questions" },
        { title: "Verified Testimonials", href: "/testimonials", desc: "Client testimonials and reviews" },
      ]
    },
    {
      title: "Contact",
      href: "/contact"
    },
  ],

  // Ergonomic Compact Footer Navigation (Formatted for mobile 3-column & desktop fit)
  footerLinks: {
    company: [
      { label: "About Us", href: "/about" },
      { label: "Our Team", href: "/team" },
      { label: "Careers", href: "/careers" },
      { label: "Contact", href: "/contact" },
      { label: "Security", href: "/security" },
    ],
    services: [
      { label: "Web Apps", href: "/services/web-development" },
      { label: "Mobile Apps", href: "/services/mobile-app-development" },
      { label: "Applied AI", href: "/ai-development" },
      { label: "Software", href: "/services/custom-software" },
      { label: "SaaS Cloud", href: "/services/saas-development" },
      { label: "DevOps", href: "/services/cloud-devops" },
    ],
    resources: [
      { label: "Tech Blog", href: "/blog" },
      { label: "Case Studies", href: "/case-studies" },
      { label: "Portfolio", href: "/portfolio" },
      { label: "Tech Stack", href: "/technologies" },
      { label: "FAQs", href: "/faq" },
    ],
    legal: [
      { label: "Privacy Policy", href: "/privacy-policy" },
      { label: "Terms & Conditions", href: "/terms-and-conditions" },
      { label: "Cookie Policy", href: "/cookie-policy" },
    ]
  }
};
